import { useLayoutEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import ConnectController from './ConnectController';
import { useConnectAuthCode } from './hooks/useConnectAuthCode';

/**
 * /connect 페이지 진입점.
 *
 * 책임:
 *  - URL 쿼리에서 authCode를 추출 (없으면 sessionStorage fallback)
 *  - 진입 즉시 referrer 정책 강제 + 쿼리 스크럽 (보안: authCode가 referer로 새지 않도록)
 *  - ConnectController에 전달하여 6 상태 분기를 위임
 */
export default function ConnectPage() {
  const location = useLocation();
  const queryAuthCode = useMemo(() => new URLSearchParams(location.search).get('authCode'), [
    location.search
  ]);

  // sessionStorage 보관 코드도 참고한다 (학교 → /connect 첫 진입 후 새로고침 등의 시나리오).
  // 단, URL 쿼리에 있는 게 항상 우선이다.
  const { stored } = useConnectAuthCode();

  // 첫 페인트 전에 보안 처리: referrer 메타 + 쿼리 제거
  useLayoutEffect(() => {
    ensureNoReferrerPolicy();
    scrubQueryString();
  }, []);

  const effectiveAuthCode = queryAuthCode ?? stored?.authCode ?? null;

  return <ConnectController authCode={effectiveAuthCode} />;
}

function ensureNoReferrerPolicy() {
  const selector = 'meta[name="referrer"]';
  const existing = document.querySelector<HTMLMetaElement>(selector);
  if (existing) {
    existing.content = 'no-referrer';
    return;
  }

  const meta = document.createElement('meta');
  meta.name = 'referrer';
  meta.content = 'no-referrer';
  document.head.appendChild(meta);
}

function scrubQueryString() {
  if (!window.location.search) return;
  window.history.replaceState(null, document.title, window.location.pathname);
}
